<template>
  <pending-review
    v-if="isDisplayPendingReviewInsteadOfFailedAssessment"
    :company-type="companyType"
    :company-name="brokerName"
  />
  <layout v-else>
    <!-- <img
      v-if="brokerLogo"
      class="h-11 w-auto mx-auto md:hidden my-6"
      :src="brokerLogo"
      alt="broker logo"
    /> -->
    <h1
      v-if="showInvalidCredentialsMessage"
      class="header-text text-center"
    >
      Invalid ELD Credentials
    </h1>
    <h1
      v-else
      class="header-text text-center"
    >
      {{ showPendingELDMessages ? 'Pending' : 'Failed' }} Assessment
    </h1>
    <p
      v-if="!showPendingELDMessages && !skipShowFailedRulesToCarriers"
      class="mb-6 flex items-start text-dark-gray"
    >
      <img
        src="@/assets/info-icon.svg"
        alt="info icon"
        class="relative top-px mr-2 inline"
      />{{ companyName }} does not meet {{ totalFailedRules }} of
      {{ brokerName }}'s requirements.
    </p>
    <div class="">
      <p
        v-if="showInvalidCredentialsMessage"
        class="mb-4 text-dark-gray"
      >
        <span class="mb-4 block"
          >Your ELD account credentials appear to be invalid. Please provide
          valid ELD credentials for your
          {{ latest_carrier_eld_provider?.connect_channel?.name }} account to
          proceed.</span
        >
        You will be notified here when your ELD credentials have been
        successfully verified.
      </p>
      <p
        v-else-if="showPendingELDMessages"
        class="mb-4 text-dark-gray"
      >
        <span
          v-if="showValidCredentialsMessage"
          class="mb-4 block"
          >Your provided ELD credentials have been successfully verified.
        </span>
        You will be immediately notified when the equipment and recent activity
        from your ELD connection is verified. This may take some time.
      </p>
      <p
        v-else
        class="mb-4 text-dark-gray"
      >
        Apologies, at this time, we will not be able to connect
        {{ companyName }} to {{ brokerName }} due to failing one or more of its
        requirements.
      </p>
    </div>
    <div
      v-if="hasFailedSafetyRating"
      class="mb-4"
    >
      <p class="leading-1 m-0 text-dark-gray">
        For more information, or to submit a Corrective Action Plan (CAP) for
        review, please contact this Broker directly at
        <a
          v-if="broker?.support_email?.length > 0"
          class="text-link underline"
          :href="`mailto:${broker?.support_email}`"
        >
          {{ broker?.support_email }}</a
        >
        <span class="text-dark-gray">.</span>
      </p>
    </div>
    <div v-else>
      <p
        v-if="broker?.support_email"
        class="mb-4 text-dark-gray"
      >
        <span>For more information, contact this Broker directly at </span>
        <!-- TODO set dynamic link  -->
        <a
          class="text-link underline"
          :href="`mailto:${broker?.support_email}`"
          >{{ broker?.support_email }}</a
        >
        <span>.</span>
      </p>
    </div>
    <!-- <p class="text-dark-gray mb-4">Failed {{ totalFailedRules == 1 ? 'Requirement' : 'Requirements' }}:</p>
    <div v-for="(rule, index) in failedRules" :key="rule">
      <div class="flex gap-4 justify-between" :class="{'mb-6 md:mb-8': (index === totalFailedRules - 1)}">
          <p class="text-body-color text-xs">
            {{ rulesSyntax[rule]?.label }}
          </p>
          <p class="fail-status">Fail</p>
      </div>
      <div v-if="index !== (totalFailedRules - 1)" class="my-4 mb:my-6 border-b-2 border-light-gray"></div>
    </div> -->
    <div
      v-if="!showPendingELDMessages && !skipShowFailedRulesToCarriers"
      class="mb-6 flex w-full flex-col gap-4"
    >
      <div
        v-for="(classification, index) in failedRulesFormatted"
        :key="`${classification?.name}-${index}`"
        class="rounded-md border border-light-gray p-2"
      >
        <p class="mb-1 text-base text-dark-gray">
          {{ classification?.name }}
        </p>
        <div class="flex flex-col">
          <div
            v-if="classification?.manually_approval?.length > 0"
            class="mb-3"
          >
            <p class="text-xs text-dark-gray">Pending Approval</p>
            <p class="mb-2 text-xxs text-dark-gray">
              These rules must be manually approved by an authorized
              representative of {{ brokerName }} and will fail until approved.
            </p>
            <div
              v-for="(rule, idx) in classification?.manually_approval"
              :key="`classification-approval-${idx}`"
              class="flex justify-between gap-4"
            >
              <p class="flex-1 pt-1 text-xs text-body-color">
                <span v-if="showRuleLabels">{{
                  syntaxData?.[classification?.id]?.[rule?.rule]?.label
                }}</span>
                <span
                  v-else
                  class="loading-gradient relative -top-1 block w-full rounded-md bg-light-gray py-1 text-transparent"
                  >Loading...</span
                >
              </p>
              <p
                v-if="
                  rule?.rule == 'has_verified_physical_location_activity' &&
                  latest_carrier_eld_provider?.has_setup_manual_connection ==
                    true
                "
                class="review-status text-center"
              >
                Pending
              </p>
              <p
                v-else
                class="fail-status"
              >
                Fail
              </p>
            </div>
          </div>

          <p class="text-xs text-dark-gray">Failed Rules</p>
          <p class="mb-2 text-xxs text-dark-gray">
            These rules are enforced automatically and cannot be modified by
            Highway.
          </p>

          <div
            v-for="(rule, idx) in classification?.rules"
            :key="`${classification?.name}-${index}-${idx}`"
            class="flex justify-between gap-4"
          >
            <p class="flex-1 pt-1 text-xs text-body-color">
              <span v-if="showRuleLabels">{{
                syntaxData?.[classification?.id]?.[rule?.rule]?.label
              }}</span>
              <span
                v-else
                class="loading-gradient relative -top-1 block w-full rounded-md bg-light-gray py-1 text-transparent"
                >Loading...</span
              >
            </p>
            <p
              v-if="
                rule?.rule == 'has_verified_physical_location_activity' &&
                latest_carrier_eld_provider?.has_setup_manual_connection == true
              "
              class="review-status text-center"
            >
              Pending
            </p>
            <p
              v-else
              class="fail-status"
            >
              Fail
            </p>
          </div>
        </div>
      </div>
    </div>
    <button-main
      v-if="showInvalidCredentialsMessage"
      variant="primary"
      class="mt-3"
      @click="handleVerifyRedirectUpdate()"
    >
      Update ELD Credentials
    </button-main>
    <button-main
      v-if="
        ['carrier', 'broker'].includes(companyType) &&
        hasFailedPhysicalLocationActivityVerification == true &&
        !showPendingELDMessages
      "
      class="mb-4"
      @click="handleVerifyRedirect()"
    >
      Verify Equipment
      <!-- <img class="inline link-icon" src="@/assets/link-icon.svg" alt="" /> -->
      <svg
        class="f-link-icon inline"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 6.5625H7.5C6.94772 6.5625 6.5 7.01022 6.5 7.5625V17.5625C6.5 18.1148 6.94772 18.5625 7.5 18.5625H17.5C18.0523 18.5625 18.5 18.1148 18.5 17.5625V12.5625"
          stroke="currentColor"
          stroke-width="2"
        />
        <path
          d="M18.6748 6.34082L14.0262 10.9895M18.6748 6.34082L18.6748 9.99122M18.6748 6.34082L15.0244 6.34082"
          stroke="currentColor"
          stroke-width="2"
        />
      </svg>
    </button-main>
    <button-main
      v-if="['carrier', 'broker'].includes(companyType)"
      :variant="
        showInvalidCredentialsMessage
          ? 'secondary'
          : showPendingELDMessages
            ? 'primary'
            : hasFailedPhysicalLocationActivityVerification == true
              ? 'secondary'
              : 'primary'
      "
      :class="[showPendingELDMessages ? 'mt-4' : '']"
      @click="$router.push('/carrier/brokers')"
    >
      Go to Carrier Portal
      <!-- <img class="inline link-icon" src="@/assets/link-icon.svg" alt="" /> -->
      <svg
        class="f-link-icon inline"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 6.5625H7.5C6.94772 6.5625 6.5 7.01022 6.5 7.5625V17.5625C6.5 18.1148 6.94772 18.5625 7.5 18.5625H17.5C18.0523 18.5625 18.5 18.1148 18.5 17.5625V12.5625"
          stroke="currentColor"
          stroke-width="2"
        />
        <path
          d="M18.6748 6.34082L14.0262 10.9895M18.6748 6.34082L18.6748 9.99122M18.6748 6.34082L15.0244 6.34082"
          stroke="currentColor"
          stroke-width="2"
        />
      </svg>
    </button-main>
    <button-main
      v-if="companyType == 'dispatcher'"
      @click="$router.push('/dispatcher')"
    >
      Go to Dispatcher Portal
      <!-- <img class="inline link-icon" src="@/assets/link-icon.svg" alt="" /> -->
      <svg
        class="f-link-icon inline"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5 6.5625H7.5C6.94772 6.5625 6.5 7.01022 6.5 7.5625V17.5625C6.5 18.1148 6.94772 18.5625 7.5 18.5625H17.5C18.0523 18.5625 18.5 18.1148 18.5 17.5625V12.5625"
          stroke="currentColor"
          stroke-width="2"
        />
        <path
          d="M18.6748 6.34082L14.0262 10.9895M18.6748 6.34082L18.6748 9.99122M18.6748 6.34082L15.0244 6.34082"
          stroke="currentColor"
          stroke-width="2"
        />
      </svg>
    </button-main>
    <button-main
      v-if="showPendingELDMessages && !showInvalidCredentialsMessage"
      variant="secondary"
      class="mt-3"
      @click="handleVerifyRedirectUpdate()"
    >
      Update ELD Credentials
    </button-main>
    <div
      v-if="hasFailedScheduledAuto || needsCOIStatement"
      class="mt-3"
    >
      <p class="leading-1 m-0 text-xxs text-body-color">
        Please instruct your insurance agency to email your Certificate of
        Insurance (COI) to
        <a
          class="text-link text-xxs underline"
          href="mailto:insurance@certs.highway.com"
          >insurance@certs.highway.com</a
        >
        <span class="text-xxs text-body-color">.</span>
        <span
          v-if="hasFailedScheduledAuto"
          class="font-bold"
        >
          Your COI must include a schedule of VINs for the Scheduled Auto
          policy.</span
        >
      </p>
    </div>
  </layout>
</template>

<script>
import Button from '../Button.vue';
import PendingReview from './PendingReview.vue';
import Layout from '../layouts/HoldingTankLayout.vue';

export default {
  name: 'HeldForFailedAssessment',
  components: {
    'button-main': Button,
    Layout,
    PendingReview,
  },
  props: {
    companyType: String,
    companyName: String,
    loading: Boolean,
    failedRules: {
      type: Array,
      default: () => [],
    },
    uniqueFailedRules: Array,
    incompleteRules: {
      type: Array,
      default: () => [],
    },
    uniqueIncompleteRules: Array,
    totalRules: Number,
    rulesSyntax: Object,
    supportEmail: String,
    brokerLogo: String,
  },
  data() {
    return {
      showRuleLabels: false,
      syntaxData: false,
      publicBrokerName: null,
    };
  },
  computed: {
    brokerName() {
      return (
        this.$store.state.carriers.carrierData?.connection?.issuer
          ?.legal_name ||
        this.broker?.companyData?.legal_name ||
        this.publicBrokerName
      );
    },
    onboardingPacketId() {
      return (
        this.$store.state.onboardingPacket?.onboarding_id ||
        this.$store.state.onboardingPacket?.id ||
        this.$route?.params?.id
      );
    },
    isDisplayPendingReviewInsteadOfFailedAssessment() {
      const { carriers } = this.$store.state || {};

      return (
        carriers?.carrierData?.connection?.issuer
          ?.is_display_pending_review_instead_of_failed_assessment ||
        carriers?.failedRulesAssessmentData
          ?.is_display_pending_review_instead_of_failed_assessment ||
        false
      );
    },
    showPendingELDMessages() {
      return (
        this.hasFailedPhysicalLocationActivityVerification &&
        (this.latest_carrier_eld_provider?.has_setup_manual_connection ==
          true ||
          this.latest_carrier_eld_provider?.connect_channel?.eld_type ==
            'eld_exempt')
      );

      // Don't allow update credentials button to show when a carrier's eld_exempt is for another onboarding packet
      // return (
      //   this.hasFailedPhysicalLocationActivityVerification &&
      //   this.latest_carrier_eld_provider?.has_setup_manual_connection == true &&
      //   (this.latest_carrier_eld_provider?.connect_channel?.eld_type !=
      //     "eld_exempt" ||
      //     (this.latest_carrier_eld_provider?.connect_channel?.eld_type ==
      //       "eld_exempt" &&
      //       this.latest_carrier_eld_provider?.onboarding_packet_id ==
      //         this.onboardingPacketId))
      // );
    },
    skipShowFailedRulesToCarriers() {
      return (
        this.$store.state.carriers?.carrierData?.connection?.issuer
          ?.skip_showing_failed_rules_to_carriers ||
        this.$store.state.carriers?.failedRulesAssessmentData
          ?.skip_showing_failed_rules_to_carriers
      );
    },
    totalFailedRules() {
      return this.uniqueFailedRules?.length;
    },
    failedRulesFormatted() {
      const classifications = this.failedRules;

      const formattedRule = classifications.map((classification) => {
        const filteredRules =
          classification?.rules?.filter(
            (r) => !r?.rule?.includes('broker_approval')
          ) || [];
        const manuallyApproved =
          classification?.rules?.filter((r) =>
            r?.rule?.includes('broker_approval')
          ) || [];

        return {
          ...classification,
          rules: filteredRules,
          manually_approval: manuallyApproved,
        };
      });

      return formattedRule;
    },
    broker() {
      return this.$store.state.company;
    },
    brokerLegalNameForUrl() {
      return this.brokerName?.trim()?.replace(/\s/g, '+');
    },
    hasFailedPhysicalLocationActivityVerification() {
      const eldSensitiveRuleSets =
        this.$store.state.onboardingPacket.eld_sensitive_rule_sets;
      let returnVal = false;
      let self = this;
      eldSensitiveRuleSets.forEach((rule_set) => {
        if (self.uniqueFailedRules?.includes(rule_set)) {
          returnVal = true;
        }
      });

      return returnVal;
    },
    hasFailedScheduledAuto() {
      return this.uniqueFailedRules?.includes(
        'has_vin_if_auto_policy_is_scheduled_autos'
      )
        ? true
        : false;
    },
    hasFailedSafetyRating() {
      return this.uniqueFailedRules?.includes(
        'safety_rating_satisfactory_or_unrated'
      )
        ? true
        : false;
    },
    latest_carrier_eld_provider() {
      if (this.$store.state.onboardingPacket?.latest_carrier_eld_provider) {
        return this.$store.state.onboardingPacket?.latest_carrier_eld_provider;
      } else if (
        this.$store.state.carriers?.carrierData?.latest_carrier_eld_provider
      ) {
        return this.$store.state.carriers?.carrierData
          ?.latest_carrier_eld_provider;
      }
      return null;
    },
    needsCOIStatement() {
      let val = false;
      let rulesToCheck = [
        'bipd_requirement',
        'cargo_requirement',
        'general_liability_requirement',
        'trailer_interchange_requirement',
        'multi_currency_bipd_requirement',
        'multi_currency_cargo_requirement',
        'multi_currency_general_liability_requirement',
        'multi_currency_trailer_interchange_requirement',
        'multi_currency_contingent_auto_requirement',
        'multi_currency_contingent_cargo_requirement',
        'bipd_insurance_limit_gteq_750_000',
        'future_auto_and_cargo_requirement',
      ];
      rulesToCheck.forEach((rule) => {
        if (this.uniqueFailedRules?.includes(rule)) {
          val = true;
        }
      });
      return val;
    },
    currentEldIntegration() {
      return this.$store.state.onboardingPacket?.current_eld_integration;
    },
    showValidCredentialsMessage() {
      return (
        this.latest_carrier_eld_provider?.connect_channel
          ?.is_auto_eld_credentials &&
        this.currentEldIntegration?.eld_credentials_verified
      );
    },
    showInvalidCredentialsMessage() {
      return (
        this.latest_carrier_eld_provider?.connect_channel
          ?.is_auto_eld_credentials &&
        this.currentEldIntegration?.eld_credentials_verified === false
      );
    },
    eldProviders() {
      if (this.$store.state.onboardingPacket?.eld_providers?.length > 0) {
        let all = [
          ...(this.$store.state.onboardingPacket?.eld_providers ?? []),
        ];
        return all.filter((el) => el?.eld_type !== 'eld_exempt');
        // all = all.filter(el => el?.eld_type !== 'eld_exempt');
        // return all.sort(function(a, b) {
        //   return a.id - b.id;
        // });
      }
      return [];
    },
    eldExempt() {
      if (this.$store.state.onboardingPacket?.eld_providers?.length > 0) {
        return this.$store.state.onboardingPacket?.eld_providers?.find(
          (el) => el?.eld_type === 'eld_exempt'
        );
      }
      return null;
    },
  },
  watch: {
    failedRules: {
      deep: true,
      handler() {
        let self = this;
        let rVal = {};
        self.failedRules.forEach(async function (el) {
          let id = el?.id;
          let syntax = await self.$store.dispatch(
            'carriers/getRulesSyntaxByClassificationId',
            id
          );
          rVal[id] = syntax;
        });
        self.syntaxData = rVal;
        if (typeof self.syntaxData === 'object') {
          setTimeout(function () {
            self.showRuleLabels = true;
          }, 1000);
        }
      },
      immediate: true,
    },
  },
  created() {
    if (this.eldProviders?.length < 1) {
      this.$store.dispatch('onboardingPacket/getEldProviders');
    }
  },
  mounted() {
    if (!this.brokerName) {
      this.fetchPublicBrokerName();
    }
  },
  methods: {
    async fetchPublicBrokerName() {
      const publicDetails = await this.$store.dispatch(
        'brokers/getLogoByClientId',
        localStorage.getItem('client_id')
      );
      this.publicBrokerName = publicDetails?.data?.legal_name;
    },
    handleVerifyRedirect() {
      if (this.onboardingPacketId > 0) {
        this.$router.push({
          name: 'Carrier Verify Equipment',
          params: {
            id: this.onboardingPacketId,
          },
        });
      } else {
        this.$router.push({
          name: 'Carrier Dashboard',
          query: {
            connectEld: `true`,
          },
        });
      }
    },
    async handleVerifyRedirectUpdate() {
      if (
        this.latest_carrier_eld_provider?.connect_channel?.eld_type ==
          'eld_exempt' &&
        this.eldExempt?.id &&
        !this.currentEldIntegration
      ) {
        await this.$store.dispatch(
          'onboardingPacket/createCarrierEldProvider',
          this.eldExempt?.id
        );
      }
      await this.$store.commit('integrations/setUpdateEld', true);
      this.handleVerifyRedirect();
    },
  },
};
</script>
<style scoped>
.header-text {
  font-size: 26px;
  @apply mb-6 text-dark-blue md:mb-8;
}

.text-link {
  color: #e7b812;
}

.f-link-icon {
  position: relative;
  bottom: 2px;
}

.fail-status {
  padding: 4px 8px;
  background: #fff0e3;
  border-radius: 20px;
  font-size: 10px;
  width: 34px;
  height: 24px;
  @apply text-orange-500;
}

.review-status {
  padding: 4px 8px;
  background: #d6d7da;
  border-radius: 30px;
  font-size: 10px;
  width: 64px;
  height: 24px;
}
</style>
